import { render, staticRenderFns } from "./PUItem.vue?vue&type=template&id=9388098e&scoped=true"
import script from "./PUItem.vue?vue&type=script&lang=js"
export * from "./PUItem.vue?vue&type=script&lang=js"
import style0 from "./PUItem.vue?vue&type=style&index=0&id=9388098e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9388098e",
  null
  
)

export default component.exports